import classNames from 'classnames';
import styles from './LinkList.module.scss';
import { UI_Heading } from 'ui/components/1-atoms/Heading/Heading';
import { UI_Icon } from 'ui/components/1-atoms/Media/Icon/Icon';
import RightArrow from 'ui/icons/icon_right_arrow.svg';
import { UI_LinkWithIcon } from 'ui/components/1-atoms/Action/LinkWithIcon/LinkWithIcon';
import IconArrow from 'ui/icons/icon-chevron-right.svg';

export interface LinkListProps {
	className?: string;
	heading?: string;
	headingLink?: LinkProps;
	linkListItems?: LinkProps[];
}

export interface LinkProps {
	name?: string;
	url?: string;
	target?: string;
}

export const UI_LinkList = ({ className, heading, headingLink, linkListItems }: LinkListProps) => {
	const filteredLinkListItems = linkListItems?.filter((item) => item.url) ?? [];
	return (
		<div className={classNames(styles.LinkList, className)}>
			{headingLink ? (
				<a href={headingLink.url} target={headingLink.target} className={styles.LinkList_headingLinkContainer}>
					<UI_Heading
						headingLevel="h2"
						style="lg"
						className={classNames(styles.LinkList_headingLink, styles.LinkList_headingLink___withIcon)}
					>
						<span>{heading || headingLink.name}</span>

						<UI_Icon size="sm" className={styles.LinkList_headingLinkIcon}>
							<RightArrow />
						</UI_Icon>
					</UI_Heading>
				</a>
			) : heading ? (
				<UI_Heading headingLevel="h2" style="lg" className={styles.LinkList_heading}>
					{heading}
				</UI_Heading>
			) : null}
			{filteredLinkListItems?.length > 0 && (
				<ul className={styles.LinkList_items}>
					{filteredLinkListItems.map((linkListItem: LinkProps, index) => (
						<li key={index} className={styles.LinkList_item}>
							{
								<>
									<UI_LinkWithIcon
										className={styles.LinkList_itemLink}
										url={linkListItem.url}
										target={linkListItem.target}
										icon={
											<span className={styles.LinkList_itemLink_arrowLinkIcon}>
												<IconArrow />
											</span>
										}
										reverseOrder
										alignToTop
										text={linkListItem.name ?? linkListItem.url}
									/>
								</>
							}
						</li>
					))}
				</ul>
			)}
		</div>
	);
};
